import React from "react";
import {
  LinkRecord,
  LinkRecordAction,
  LinkRecordActionType,
} from "winslow-core";
import { formatDate } from "winslow-core";
import { SquareX } from "lucide-react";
import {
  getAppLogoFromLinkRecord,
  getActivityLogoFilePathInMode,
  getAppLogo,
} from "winslow-core";
import "./ResourceActionMulti.css";

interface ResourceActionMultiProps {
  linkRecordActions: LinkRecordAction[];
  linkRecords: LinkRecord[] | undefined;
  supportedApps: any;
  storeUser: any;
  formatActionType: (actionType: LinkRecordActionType) => string;
}

export const ResourceActionMulti: React.FC<ResourceActionMultiProps> = ({
  linkRecordActions,
  linkRecords,
  supportedApps,
  storeUser,
  formatActionType,
}) => {
  return (
    <div className="multi-action-messages">
      {linkRecordActions.map((action) => {
        const actionLinkRecord = linkRecords?.find(
          (linkRecord) => linkRecord.id === action.linkRecordId
        );
        const link = actionLinkRecord?.links?.[0];

        // Use linkRecord if available, otherwise fallback to action fields
        const title = link?.title || action.fileName || "Removed Resource";
        const url = link?.url || action.fileUrl;
        const appId = link?.appId || action?.appId || "OTHER";

        const appLogo = `/icons/light-mode/app_logos/${getAppLogo(
          appId,
          title,
          supportedApps,
          "-activity.svg"
        )}`;

        return (
          <div key={action.id} className="multi-action-message">
            <div className="multi-action-message-top-row">
              <div className="multi-link-record-activity-logo">
                <img src={appLogo} alt="" />
              </div>
              <div className="multi-link-record-activity-title-container">
                <div className="multi-link-record-activity-title">
                  {title === "Removed Resource" ? (
                    <em>Removed Resource</em>
                  ) : (
                    title
                  )}
                </div>

                {url && (
                  <div className="multi-link-record-activity-url-card-url">
                    <a href={url} target="_blank" rel="noreferrer noopener">
                      {url}
                    </a>
                  </div>
                )}
              </div>
            </div>
            <hr className="multi-action-message-divider" />
            <div className="multi-action-message-bottom-row">
              <div className="multi-action-type-icon">
                {action.actionType === LinkRecordActionType.CONNECTED && (
                  <img src="/icons/action-created.svg" alt="" />
                )}
                {action.actionType === LinkRecordActionType.CREATED && (
                  <img src="/icons/action-created.svg" alt="" />
                )}
                {action.actionType === LinkRecordActionType.UPDATED && (
                  <img src="/icons/action-updated.svg" alt="" />
                )}
                {action.actionType === LinkRecordActionType.DELETED && (
                  <SquareX style={{ color: "#f61924" }} />
                )}
                {action.actionType === LinkRecordActionType.EMBEDDED && (
                  <img src="/icons/action-embedded.svg" alt="" />
                )}
              </div>

              <span className="multi-action-type">
                {formatActionType(action.actionType)}
              </span>
              {action.actorAvatarUrl && (
                <span className="multi-action-actor-avatar">
                  <img
                    src={action.actorAvatarUrl}
                    alt="Actor Avatar"
                    className="multi-action-actor-avatar"
                  />
                </span>
              )}

              {action.actorDisplayName && (
                <span className="multi-action-actor-name">
                  by {action.actorDisplayName}
                </span>
              )}

              <span className="multi-action-date">
                {formatDate(action.createdAt)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
